// In production, we register a service worker to serve assets from local cache.

// This lets the app load faster on subsequent visits in production, and gives
// it offline capabilities. However, it also means that developers (and users)
// will only see deployed updates on the "N+1" visit to a page, since previously
// cached resources are updated in the background.

// To learn more about the benefits of this model, read https://goo.gl/KwvDNy.
// This link also includes instructions on opting out of this behavior.

const isLocalhost = Boolean(
  window.location.hostname === 'localhost' ||
  // [::1] is the IPv6 localhost address.
  window.location.hostname === '[::1]' ||
  // 127.0.0.1/8 is considered localhost for IPv4.
  window.location.hostname.match(/^127(?:\.(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)){3}$/)
);

const appVer = "2.2.8";

function registerValidSw(swUrl, config) {
  console.log(`regSW.registerValidSw: swUrl:  ${swUrl}`);
  navigator.serviceWorker
    .register(swUrl)
    .then((registration) => {
      console.log(`regSW.registerValidSw: scope: ${registration.scope}`);
      const activeWorker = registration.active;
      // if the service worker is already installed and active
      if (activeWorker != null) {
        console.log('regSW.registerValidSw: service worker is already active. Inizializing queue...');
        activeWorker.postMessage({ type: "showVersion", appVer: appVer });
        activeWorker.postMessage({ type: "autoSyncQueue" });
      }
      registration.onupdatefound = () => {
        const installingWorker = registration.installing;
        if (installingWorker == null) {
          return;
        }
        console.log('regSW.registerValidSw: service worker is installing...');
        installingWorker.onstatechange = () => {
          console.log(`regSW.registerValidSw: installingWorker.state:  ${installingWorker.state}`);
          if (installingWorker.state === 'installed') {
            if (navigator.serviceWorker.controller) {
              // At this point, the updated precached content has been fetched,
              // but the previous service worker will still serve the older
              // content until all client tabs are closed.
              console.log(
                'regSW.registerValidSw: New content is available and will be used when all ' +
                'tabs for this page are closed. See https://bit.ly/CRA-PWA.'
              );

              // Execute callback
              if (config && config.onUpdate) {
                config.onUpdate(registration);
              }
            } else {
              // At this point, everything has been precached.
              // It's the perfect time to display a
              // "Content is cached for offline use." message.
              console.log('regSW.registerValidSw: Content is cached for offline use.');

              // Execute callback
              if (config && config.onSuccess) {
                config.onSuccess(registration);
              }
            } 
          } else if(installingWorker.state === 'activated') {
            console.log('regSW.registerValidSw: service worked has been activated, reloading page...');
            window.location.reload();
          }
        };
      };
    })
    .catch((ex) => {
      console.error('regSW.registerValidSw: Error during service worker registration:', ex);
    });
}

function checkValidServiceWorker(swUrl, config) {
  console.log(`checkValidServiceWorker: swUrl:  ${swUrl}`);
  // Check if the service worker can be found. If it can't reload the page.
  fetch(swUrl)
    .then((response) => {
      // Ensure service worker exists, and that we really are getting a JS file.
      if (
        response.status === 404 ||
        response.headers.get('content-type').indexOf('javascript') === -1
      ) {
        console.error(`checkValidServiceWorker: No service worker found!`);
        // No service worker found. Probably a different app. Reload the page.
        navigator.serviceWorker.ready.then((registration) => {
          registration.unregister().then(() => {
            window.location.reload();
          });
        });
      } else {
        // Service worker found. Proceed as normal.
        registerValidSw(swUrl, config);
      }
    })
    .catch(() => {
      console.warn('checkValidServiceWorker: No internet connection found. App is running in offline mode.');
    });
}

export default function register(config) {
  // if (process.env.NODE_ENV === 'production' && 'serviceWorker' in navigator) {
  if ('serviceWorker' in navigator) {
    // The URL constructor is available in all browsers that support SW.
    const publicUrl = new URL(process.env.PUBLIC_URL, window.location);
    if (publicUrl.origin !== window.location.origin) {
      // Our service worker won't work if PUBLIC_URL is on a different origin
      // from what our page is served on. This might happen if a CDN is used to
      // serve assets; see https://github.com/facebookincubator/create-react-app/issues/2374
      console.error(`regSW.register: publicUrl (${publicUrl}) differs from window.location.origin (${window.location.origin}).`);
      console.error(`regSW.register: Unable to register the service worker.`);
      return;
    }

    window.addEventListener('load', () => {
      console.log(`regSW.register: load event: process.env.NODE_ENV:  ${process.env.NODE_ENV}`);
      let swUrl = `${process.env.PUBLIC_URL}/sw.js`;
      let react_app_api_url = window._config?.REACT_APP_API_URL || process.env.REACT_APP_API_URL;
      console.log(`regSW.register: load event: react_app_api_url: ${react_app_api_url}`);
      let max_queue_retries = window._config?.REACT_APP_MAX_QUEUE_RETRIES || process.env.REACT_APP_MAX_QUEUE_RETRIES || 100;
      let fetch_timeout_sec = window._config?.REACT_APP_FETCH_TIMEOUT_SEC || process.env.REACT_APP_FETCH_TIMEOUT_SEC || 30;
      let queryString = new URLSearchParams({
        apiUrl: react_app_api_url + "api",
        env: process.env.NODE_ENV,
        mqret: max_queue_retries,
        ftouts: fetch_timeout_sec,
        appVer: appVer
      });

      swUrl = swUrl + "?" + queryString;
      console.log(`regSW.register: load event: isLocalhost: ${isLocalhost} swUrl: ${swUrl}`);
      if (isLocalhost) {
        // This is running on localhost. Lets check if a service worker still exists or not.
        checkValidServiceWorker(swUrl, config);
      } else {
        // Is not local host. Just register service worker
        registerValidSw(swUrl, config);
      }
    });
  }
}

export function unregister() {
  if ('regSW.serviceWorker' in navigator) {
    navigator.serviceWorker.ready.then((registration) => {
      registration.unregister();
    });
  }
}
